/**
 * LOS CONTADORES DEL PERFIL PÚBLICO — visitas y clics de contacto.
 *
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║  LO INCREMENTA EL SERVIDOR, SIEMPRE. NUNCA LA PANTALLA.                   ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 *
 * Hasta hoy este trabajo lo hacían las callables `recordProfileView` /
 * `recordProfileClick`, que con el dominio en Postgres se OMITEN ENTERAS: el API
 * tenía la lectura (`GET /workshops/:id/profile-views`) y cero escritura, así que
 * el taller veía su gráfico plano en 0 sobre un negocio que sí recibe visitas.
 *
 * El cuerpo NO lleva cantidades: dice a QUIÉN se mira y —en el clic— QUÉ se
 * pulsó. La suma la hace la base. Abrir la columna al navegador sería un contador
 * público auto-escribible, que es justo lo que se cerró con el rating y con el
 * tiempo de respuesta.
 *
 * ⚠️ ESTAS DOS FUNCIONES NO LANZAN NUNCA HACIA ARRIBA por decisión del llamador
 * (`src/utils/analytics.js` las envuelve en `.catch(() => {})`): contar una visita
 * no puede romper la pantalla que se está visitando. Aquí SÍ se deja propagar el
 * error para que quien llame decida — un adaptador que se traga los fallos es un
 * adaptador que no se puede probar.
 */
import { apiFetch } from './client';

/** El objetivo, tal como lo espera el API: EXACTAMENTE uno de los dos. */
function objetivo(targetType, targetId) {
  return targetType === 'workshop' ? { workshopId: targetId } : { mechanicId: targetId };
}

/**
 * UNA VISITA AL PERFIL. Devuelve `{ counted, reason }`.
 *
 * `counted: false` con `reason: 'owner'` o `'duplicate'` es el funcionamiento
 * normal (el dueño no infla su métrica; una vez por visitante, perfil y día), no
 * un fallo.
 */
export async function recordProfileView(targetType, targetId, { apiFetchImpl, signal } = {}) {
  const call = apiFetchImpl || apiFetch;
  return call('/profile-metrics/views', {
    method: 'POST',
    body: objetivo(targetType, targetId),
    signal,
  });
}

/**
 * UN CLIC DE CONTACTO. Devuelve `{ counted, reason }`.
 *
 * ⚠️ `reason: 'unsupported'` para un TALLER es esperado y está declarado en el
 * servidor: en Postgres los cuatro contadores de clic solo existen en
 * `mechanic_profile`. En Firestore se escribían como campos sueltos del taller
 * que ninguna pantalla pinta.
 */
export async function recordProfileClick(type, targetType, targetId, { apiFetchImpl, signal } = {}) {
  const call = apiFetchImpl || apiFetch;
  return call('/profile-metrics/clicks', {
    method: 'POST',
    body: { ...objetivo(targetType, targetId), type },
    signal,
  });
}
